import React from 'react';
import { SERVICE_STATUS_OPTIONS } from '../../../../components/atoms/const';

// Date Render 2022-05-06T10:45:14
const renderDate = (date: string | null):string => {
  if (date) {
    const onlyDate = date.split('T')[0].split('-');
    return `${onlyDate[1]}/${onlyDate[2]}/${onlyDate[0]}`;
  }
  return '-';
};

// Table Header Classname
const classNameHeader = 'color-placeholder fw-bold border-color-stroke border-bottom fw-normal pb-2 fz-14';

// Status Need Dynamic Style and Based on Code
const renderStatusService = (code: number): {style: React.CSSProperties, status: string} => {
  if (code === 1) {
    return {
      style: { backgroundColor: 'rgba(235,87,87,0.1)', color: '#EB5757' },
      status: SERVICE_STATUS_OPTIONS.find((x) => x.value === 1)?.label ?? '-',
    };
  } if (code === 2) {
    return {
      style: { backgroundColor: 'rgba(47,128,237,0.1)', color: '#2F80ED' },
      status: SERVICE_STATUS_OPTIONS.find((x) => x.value === 2)?.label ?? '-',
    };
  } if (code === 3) {
    return {
      style: { backgroundColor: 'rgba(47,128,237,0.1)', color: '#2F80ED' },
      status: SERVICE_STATUS_OPTIONS.find((x) => x.value === 3)?.label ?? '-',
    };
  }
  return {
    style: { backgroundColor: 'rgba(33,150,83,0.1)', color: '#219653' },
    status: '-',
  };
};

export type RefObject = {
  // eslint-disable-next-line no-unused-vars
  handleChangePage: (x: number) => void
}

export {
  renderDate, classNameHeader, renderStatusService,
};
